/**
 * Device Types
 *
 * 디바이스 타입을 정의하는 열거형
 */

/**
 * 디바이스 타입 열거형
 *
 * @description PC, 모바일, 태블릿 등 디바이스 유형을 구분
 */
export enum Device {
  /** PC/데스크톱 */
  PC = "PC",
  /** 모바일/스마트폰 */
  MOBILE = "MOBILE",
  /** 태블릿 */
  TABLET = "TABLET",
  /** 뱅킹 앱 */
  APP = "APP",
}
